export const patterns = {
    email: '^\\S+@\\S+\\.\\S+$',
    emailOrLegacyMergeField: '(~.+~)|(\\S+@\\S+\\.\\S+)$',
    emailOrLegacyOrLiquidMergeField: '(~.+~)|(\\[\\[.+\\]\\])|(\\S+@\\S+\\.\\S+)$',
};

export const REGEX_CUSTOM_EMAIL_ADDRESS_WITH_MERGE_FIELD_SUPPORT = /^(.+\s)?(<)?((~.+~)|(\S+@\S+\.[a-zA-Z]+))(>)?$/;
export const REGEX_CUSTOM_EMAIL_ADDRESS = /^(.+\s)?(<)?(\S+@\S+\.[a-zA-Z]+)(>)?$/;
export const MERGE_FIELD_REGEX = /^\s*((\[\[.+]])|(~.+~))\s*$/;

export const REGEX_CUSTOM_EMAIL_ADDRESS_WITH_LIQUID_MERGE_FIELD_SUPPORT = /^(.+\s)?(<)?((~.+~)|(\S+@\S+\.[a-zA-Z]+)|(\[\[.+\]\]))(>)?$/;

export const hasValidDomain = (email) => {
    const keapMatcher = new RegExp('.*@keap\.app$'); // eslint-disable-line no-useless-escape
    const infusionmailMatcher = new RegExp('.*@infusionmail\.com$'); // eslint-disable-line no-useless-escape

    return !keapMatcher.test(email) && !infusionmailMatcher.test(email);
};

export const stripHtml = (str) => str && str.replace(/(<([^>]+)>)/ig, '').trim();

export const isValidEmailAddress = (email) => RegExp(patterns.email).test(email);

export const complianceThresholds = {
    averageEngagementDaysUpperLimit: 100,
    averageEngagementDaysHealthyLimit: 30,
    bounceRateUpperLimit: 5.0,
    bounceRateHealthyLimit: 2.5,
    complaintRateUpperLimit: 0.1,
    complaintRateHealthyLimit: 0.05,
};

// TODO: make page size configurable from dropdown pagination control dropdown EO-4455
export const PAGINATION_SIZE = 25;

export function sortByKey(array, key) {
    return array.sort((a, b) => {
        const x = a[key]; const y = b[key];

        return ((x > y) ? -1 : ((x < y) ? 1 : 0));
    });
}

export const getEmailLabel = ({ fullName, email }) => `${fullName} (${email})`;

export const getEmailValue = ({ fullName, email }) => `${fullName} <${email}>`;
